"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = withModalWindow;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_modal_1 = __importDefault(require("react-modal"));
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("@store/slices/modalSlice");
function withModalWindow(WrappedComponent) {
    return function (props) {
        var activeModal = (0, react_redux_1.useSelector)(function (state) { return state.modalSlice; }).activeModal;
        return ((0, jsx_runtime_1.jsx)(react_modal_1.default, { isOpen: activeModal !== modalSlice_1.ActiveModal.None, ariaHideApp: false, style: {
                content: {
                    border: "none",
                    background: "none",
                    position: "absolute",
                    overflow: "hidden",
                    top: "50%",
                    left: "50%",
                    height: "100vh",
                    transform: "translate(-50%, -50%)",
                },
                overlay: { zIndex: 10000 },
            }, children: (0, jsx_runtime_1.jsx)(WrappedComponent, __assign({}, props)) }));
    };
}
